import React from 'react';
import MenuPage from '../components/MenuPage';

const LunchMenu = () => {
  return (
    <MenuPage 
      menuType="pratos"
      title="Cardápio do Almoço"
      subtitle="Pratos tradicionais brasileiros preparados com ingredientes frescos e muito sabor"
    />
  );
};

export default LunchMenu;
